import { useEffect, useState } from "react";
import { TextField } from "../common/inputFiled";

export const FriendAddressPage = ({ data }) => {
  const [formData, setFormData] = useState({
    home: {
      flat_number: "",
      building_name: "",
      street_name: "",
      city_region_country: "",
      pin_code: "",
      google_map_link: "",
    },
    work: {
      flat_number: "",
      building_name: "",
      street_name: "",
      city_region_country: "",
      pin_code: "",
      google_map_link: "",
    },
    work_phone: "",
  });

  // ✅ Load data from parent when available
  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const addr = data[0]; // show first address object
      setFormData({
        home: {
          flat_number: addr?.home?.flat_number || "",
          building_name: addr?.home?.building_name || "",
          street_name: addr?.home?.street_name || "",
          city_region_country: addr?.home?.city_region_country || "",
          pin_code: addr?.home?.pin_code || "",
          google_map_link: addr?.home?.google_map_link || "",
        },
        work: {
          flat_number: addr?.work?.flat_number || "",
          building_name: addr?.work?.building_name || "",
          street_name: addr?.work?.street_name || "",
          city_region_country: addr?.work?.city_region_country || "",
          pin_code: addr?.work?.pin_code || "",
          google_map_link: addr?.work?.google_map_link || "",
        },
        work_phone: addr?.work_phone || "",
      });
    }
  }, [data]);

  return (
    <div>
      <div className="rounded-2xl p-4 min-[900px]:p-6 border border-gray-100 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900">Address</h2>

        <div className="h-[calc(100dvh-11rem)] min-[900px]:h-[83dvh] overflow-y-auto mt-4">
          <div className="grid gap-4">
            {["home", "work"].map((type) => (
              <div key={type}>
                <h3 className="text-base font-semibold text-[#6938EF]">
                  {type === "home" ? "🏠 Home Address" : "🏢 Work Address"}
                </h3>

                {[
                  ["flat_number", "Flat Number"],
                  ["building_name", "Building Name"],
                  ["street_name", "Street Name"],
                  ["city_region_country", "City, Region, Country"],
                  ["pin_code", "Pin Code"],
                  ["google_map_link", "Google Map Link"],
                ].map(([field, label]) => (
                  <TextField
                    key={field}
                    label={label}
                    placeholder={`Enter ${label}`}
                    value={formData?.[type]?.[field] || "—"}
                    disabled
                  />
                ))}
              </div>
            ))}

            <TextField
              label="Work Phone"
              placeholder="Enter Work Phone"
              value={formData?.work_phone || "—"}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};
